import { queryOptions } from '@tanstack/react-query'
import { apiGet, apiPost } from './client'

/**
 * Settings -> Easeedesk -> Oncall (v4/api, `App\Settings\Easeedesk\
 * EaseedeskOncallSettings`): grupurile furnizorului si care din ele dau
 * oameni de oncall. Forma raspunsului e inghetata in
 * `settings/easeedesk/__fixtures__/oncallSettings.json`.
 */
export interface OncallGroup {
  ID: number
  Nume: string
}

export interface OncallSettingsPage {
  groups: OncallGroup[]
  oncall_groups: number[]
}

export function oncallSettingsQuery() {
  return queryOptions({
    queryKey: ['settings', 'easeedesk', 'oncall'],
    queryFn: () => apiGet<OncallSettingsPage>('/settings/easeedesk/oncall'),
  })
}

/** `Easeedesk::edit_oncall_settings` - `groups[]`, ca din formularul vechi. */
export function saveOncallGroups(groups: string[]) {
  return apiPost<{ status: string; oncall_groups: number[] }>('/settings/easeedesk/oncall', { groups })
}
